import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;
    navigate(`/vendors?search=${encodeURIComponent(searchQuery.trim())}`);
  };

  return (
    <section className="bg-gradient-to-br from-cyan-50 via-white to-teal-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            {/* Decorative Images */}
            <div className="relative">
              <img
                alt=""
                className="absolute -top-8 -left-8 w-32 h-32 opacity-20 object-cover rounded-full"
                src="https://readdy.ai/api/search-image?query=Modern%20medical%20professional%20healthcare%20illustration%20with%20clean%20geometric%20shapes%2C%20medical%20cross%20symbols%2C%20stethoscope%20icons%2C%20and%20healthcare%20provider%20silhouettes%20in%20teal%20and%20cyan%20colors%2C%20minimalist%20design%20with%20soft%20gradients%20and%20professional%20medical%20imagery&width=600&height=400&seq=hero-bg&orientation=landscape"
              />
              <img
                alt=""
                className="absolute -bottom-4 -right-4 w-24 h-24 opacity-20 object-cover rounded-full lg:block hidden"
                src="https://readdy.ai/api/search-image?query=Medical%20healthcare%20icons%20and%20symbols%20in%20soft%20teal%20colors%2C%20stethoscope%2C%20medical%20cross%2C%20heart%20rate%20monitor%2C%20pills%2C%20medical%20equipment%20arranged%20in%20decorative%20pattern%2C%20clean%20minimalist%20healthcare%20illustration&width=400&height=400&seq=hero-decoration&orientation=squarish"
              />
            </div>

            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              It's <span className="text-teal-600">free</span> to be on Revulist
            </h1>
            <p className="text-lg text-gray-600 mb-8 max-w-lg mx-auto lg:mx-0">
              Simply search for your practice below and claim your free listing to connect with patients.
            </p>

            {/* Search Input */}
            <form onSubmit={handleSearch} className="relative max-w-md mx-auto lg:mx-0 mb-6">
              <input
                placeholder="Enter your practice name..."
                className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-teal-500 focus:outline-none"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button
                type="submit"
                className="absolute right-1 top-1 bottom-1 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-lg px-6 py-3 transition-shadow shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
              >
                Search
              </button>
            </form>

            <p className="text-sm text-gray-500 mb-6">
              Can't find it? Add your practice name, and we'll help you claim your Revulist Page.
            </p>
          </div>

          <div className="relative">
            <img
              alt="Healthcare professionals"
              className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              src="https://readdy.ai/api/search-image?query=Professional%20healthcare%20team%20of%20diverse%20doctors%20and%20nurses%20in%20modern%20medical%20facility%2C%20wearing%20white%20coats%20and%20scrubs%2C%20smiling%20confidently%20in%20bright%20clean%20hospital%20environment%20with%20medical%20equipment%2C%20professional%20medical%20photography%20with%20natural%20lighting&width=600&height=600&seq=hero-main&orientation=squarish"
            />
          </div>
        </div>
      </div>
    </section>
  );
}